import Link from 'next/link';
import { forwardRef, useEffect, useState } from 'react';

import EyeIcon from '../icons/Eye';
import EyeSlashIcon from '../icons/EyeSlash';

export interface PasswordInputProps {
  label: string;
  enableShowPassword?: boolean;
  forgotPassword?: boolean;
  onChange?: (password: string) => void;
  value?: string;
  onEnter?: (...args: any[]) => void;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  (
    { label = 'Mật khẩu', enableShowPassword, forgotPassword, onChange, value, onEnter, ...props },
    ref
  ) => {
    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState('');

    useEffect(() => {
      onChange?.(password);
    }, [password]);

    useEffect(() => {
      setPassword(value || '');
    }, [value]);

    return (
      <>
        <div className="flex justify-between gap-2">
          <label htmlFor="password">{label}</label>
          {enableShowPassword && (
            <button
              type="button"
              aria-label={showPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'}
              className="text-gray-500 hover:text-gray-900 flex items-center gap-2 transition-all cursor-pointer"
              onClick={() => setShowPassword(v => !v)}
            >
              {showPassword ? (
                <>
                  <EyeSlashIcon className="w-4 h-4" />
                  <span>Ẩn mật khẩu</span>
                </>
              ) : (
                <>
                  <EyeIcon className="w-4 h-4" />
                  <span>Hiện mật khẩu</span>
                </>
              )}
            </button>
          )}
        </div>
        <input
          type={showPassword ? 'text' : 'password'}
          id="password"
          name="password"
          className="w-full border border-gray-300 rounded-xl py-2 px-5 h-14"
          placeholder="Nhập mật khẩu của bạn"
          autoComplete="false"
          onChange={e => setPassword(e.target.value)}
          value={password}
          onKeyDown={e => {
            if (e.key === 'Enter' && onEnter) {
              onEnter();
            }
          }}
          {...props}
        />
        {forgotPassword && (
          <div className="flex justify-end">
            <Link
              href="/auth/forgot-password"
              className="text-gray-500 underline hover:text-blue-800 transition-all cursor-pointer"
            >
              Quên mật khẩu?
            </Link>
          </div>
        )}
      </>
    );
  }
);
